<script module>
  import { resolve } from '$app/paths'

  export const meta = {
    title: 'For organizations',
    teaser:
      'Explore how organizations can manage Pausly Plus subscriptions directly,\nensuring flexibility with changing member counts and enjoying exclusive features\nlike simplified onboarding and enhanced integrations.',
    sort: 2,
  }
</script>

<p>
  Rather than each employee subscribing to Pausly Plus individually and
  submitting invoices for reimbursement, Pausly facilitates a streamlined
  process by which organizations can directly handle the payment. Here's how it
  works:
</p>
<h3>Pay as You Go</h3>
<p>
  Your Pausly subscription flexibly adjusts with your organization's changing
  needs. As you welcome new members or bid farewell to current ones, Pausly
  promptly recalibrates your subscription. This ensures you're only billed for
  the actual number of active members during that billing period.
</p>
<p>
  For instance, if your monthly subscription begins with 10 members, but midway
  through the month, 5 members depart, the cost attributed to these 5 members
  for the half-month they were active will be pro-rated. This adjustment will be
  reflected and credited in your subsequent billing cycle.
</p>
<p>
  For detailed pricing information, visit our <a href={resolve('/pricing')}
    >pricing page</a
  >.
</p>
<h3>Exclusive Features for Organizations</h3>
<p>
  Beyond giving your team access to all that Pausly Pro has to offer,
  organizations benefit from an array of exclusive features. These perks include
  simplified onboarding through email domain recognition, the ability to create
  and manage teams, enhanced integrations, among others. A comprehensive list of
  all available features and their benefits can also be found on the
  <a href={resolve('/pricing')}>pricing page</a>.
</p>
